import React from 'react'

const AzimEmoji4Svg = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 12.8 12.8'
    >
      <g id='emoji-smile-svgrepo-com' transform='translate(-4.6 -4.6)'>
        <path
          id='Path_3153'
          data-name='Path 3153'
          d='M9,14a3.019,3.019,0,0,0,.864,1.219,3.336,3.336,0,0,0,4.252.031A3.026,3.026,0,0,0,15,14.044'
          transform='translate(-1 -1.5)'
          fill='none'
          stroke='#e15226'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='0.8'
        />
        <path
          id='Path_3154'
          data-name='Path 3154'
          d='M17,11a6,6,0,1,1-1.757-4.243A6,6,0,0,1,17,11Z'
          fill='none'
          stroke='#e15226'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='0.8'
          fillRule='evenodd'
        />
        <path
          id='Path_3155'
          data-name='Path 3155'
          d='M9,11V10'
          transform='translate(-0.571 -0.769)'
          fill='none'
          stroke='#e15226'
          strokeLinecap='round'
          strokeWidth='0.8'
        />
        <path
          id='Path_3156'
          data-name='Path 3156'
          d='M15,11V10'
          transform='translate(-1.429 -0.769)'
          fill='none'
          stroke='#e15226'
          strokeLinecap='round'
          strokeWidth='0.8'
        />
      </g>
    </svg>
  )
}

export default AzimEmoji4Svg
